module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin Betreiber 4.d39eccda.svg";